import { ComponentFactoryResolver, Directive, HostListener, Input, Output, ViewContainerRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { IConfirmationDialogPayload } from './confirmation-dialog-payload.interface';

@Directive({
    selector: '[confirmClick]',
    exportAs: 'confirmClick',
})
export class ConfirmationDialogDirective {
    modalRef: BsModalRef;

    @Input() message: string = 'Are you sure ?';
    @Input() boldMessage: string = '';
    @Input() channel: Subject<IConfirmationDialogPayload>;
    @Input() cancellationText = 'Cancel';
    @Input() confirmationText = 'Yes';
    @Output() confirmClick: Subject<any> = new Subject<any>();
    @Output() cancelClick: Subject<any> = new Subject<any>();
    @Input() title: string = 'Confirm operation';
    @Input() shouldChange: boolean = true;

    constructor(
        private viewContainer: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private toastr: ToastrService,
        private modalService: BsModalService
    ) {}

    @HostListener('click', ['$event'])
    onClick($event: Event) {
        if (!this.shouldChange) return;
        this.showModal();
        this.setModalProperties($event);
    }

    private showModal() {
        this.modalRef = this.modalService.show(ConfirmationDialogComponent, {
            backdrop: 'static',
            keyboard: false,
            class: 'modal-md',
            animated: true,
            ignoreBackdropClick: false,
        });
    }

    private setModalProperties($event) {
        this.modalRef.content.setMessage(this.message);
        this.modalRef.content.setBoldMessage(this.boldMessage);
        this.modalRef.content.setTitle(this.title);
        this.modalRef.content.setConfirmationText(this.confirmationText);
        this.modalRef.content.setCancellationText(this.cancellationText);
        this.modalRef.content.channel.subscribe((res: boolean) => {
            this[res ? 'handleAccept' : 'handleReject'].call(this, $event, this.modalRef.content);
        });
    }

    handleAccept($event: Event, component: ConfirmationDialogComponent) {
        this.confirmClick.next($event);
        if (this.channel && this.channel instanceof Subject) {
            component.performingAsync = true;

            component.actionSubscription = this.channel.subscribe(
                (payload: IConfirmationDialogPayload) => {
                    if (payload.result) {
                        this.modalRef.hide();
                        if (payload.message) this.toastr.success(payload.message);
                    } else {
                        if (payload.message) component.errorMessage = payload.message;
                    }

                    component.performingAsync = false;
                },
                (error: any) => {
                    component.performingAsync = false;
                }
            );
        } else {
            this.modalRef.hide();
        }
    }

    handleReject($event: Event, component: ConfirmationDialogComponent) {
        $event.preventDefault();
        $event.stopPropagation();

        if (this.cancelClick) {
            this.cancelClick.next($event);
        }
        this.modalRef.hide();
    }
}
